import classNames from 'classnames';

import { formatPlatform } from '../constants';

export function PlatformPillFilter({
  ariaLabel,
  platforms = [],
  selectedPlatform = null,
  onSelectPlatform = () => {},
}) {
  const uniquePlatforms = [...new Set(platforms.filter(Boolean))];

  return (
    <div role="group" aria-label={ariaLabel} className="inline-flex flex-wrap gap-2 rounded-full bg-solitude-500 p-1">
      <PlatformPill selected={selectedPlatform === null} onClick={() => onSelectPlatform(null)}>
        Blended
      </PlatformPill>
      {uniquePlatforms.map((platform) => (
        <PlatformPill
          key={platform}
          selected={selectedPlatform === platform}
          onClick={() => onSelectPlatform(platform)}
        >
          {formatPlatform(platform)}
        </PlatformPill>
      ))}
    </div>
  );
}

function PlatformPill({ selected, onClick, children }) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={classNames(
        'rounded-full px-4 py-2 text-sm font-semibold transition-colors',
        selected ? 'bg-[#00509D] text-white shadow-sm' : 'text-lynch-500 hover:bg-white hover:text-black-pearl-500',
      )}
    >
      {children}
    </button>
  );
}
